module.exports = __webpack_public_path__ + "static/media/logo-inverse.0b24fd9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-inverse.png
// module id = 1739
// module chunks = 0